export enum MailScenarioStatusType {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}